import React from "react";
import { FaRegCopy } from "react-icons/fa";
import "./Payment.css";

const Payment = () => {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Copied to clipboard: " + text);
  };

  return (
    <div className="payment-section">
      <h2 className="title">Secure Your Booking</h2>
      <p className="instruction">
        If you are paying via online banking, please take a screenshot of your
        payment receipt and send it to us for verification.
      </p>
      <p className="instruction">
        For bank deposits, kindly send us a photo of your deposit slip to
        confirm your reservation.
      </p>
      <p className="instruction">
        Have questions? Contact us via{" "}
        <a href="mailto:twintravelcoron.reservation@gmail.com">email</a> or
        <a href="https://www.facebook.com/TwinTravelcoron2019"> Facebook</a>.
      </p>

      <p className="note">
        Please email your payment details to{" "}
        <strong>twintravelcoron.reservations@gmail.com</strong> with the subject
        line:
        <br />
        <em>[Your Name] - Payment Confirmation for [Booking Name]</em>
      </p>

      <div className="payment-container">
        {[
          {
            bank: "PayPal",
            imgSrc:
              "https://1000logos.net/wp-content/uploads/2017/05/Color-Paypal-Logo.jpg",
            accountName: "ARLEA RAMOS",
            accountNumber: "0906-660-3788",
            qrSrc:
              "https://1000logos.net/wp-content/uploads/2017/05/Color-Paypal-Logo.jpg",
            email: "twintravel2019@yahoo.com",
          },
          {
            bank: "GCash",
            imgSrc:
              "https://images.seeklogo.com/logo-png/38/1/gcash-logo-png_seeklogo-383190.png",
            accountName: "ARLEA RAMOS",
            accountNumber: "0906-660-3788",
            qrSrc: "/gcashQR.jpg",
          },
          {
            bank: "BPI",
            imgSrc:
              "https://play-lh.googleusercontent.com/hph5YBvc0ZunCaPfZzI1HS0u3OstBmmPF0_OnqaChEih7O1wrsi-TlRg33AEt3FTero",
            accountName: "ARLEA RAMOS",
            accountNumber: "2499115014",
            qrSrc: "/bpiQR.jpg",
          },
        ].map(
          (
            { bank, imgSrc, accountName, accountNumber, qrSrc, email },
            index
          ) => (
            <div key={index} className="bank-details">
              <h3>{bank} Payment Details</h3>
              <img
                src={imgSrc}
                alt={`${bank} Logo`}
                loading="lazy"
                className="bank-logo"
              />
              <p className="copy-container">
                <strong>Account Name:</strong> {accountName}
                <button onClick={() => copyToClipboard(accountName)}>
                  <FaRegCopy />
                </button>
              </p>
              <p className="copy-container">
                <strong>Account Number:</strong> {accountNumber}
                <button onClick={() => copyToClipboard(accountNumber)}>
                  <FaRegCopy />
                </button>
              </p>
              {email && (
                <p className="copy-container">
                  <strong>Email:</strong> {email}
                  <button onClick={() => copyToClipboard(accountNumber)}>
                    <FaRegCopy />
                  </button>
                </p>
              )}

              {qrSrc && (
                <div className="qr-section">
                  <img
                    src={qrSrc}
                    alt={`${bank} QR Code`}
                    loading="lazy"
                    className="qr-code"
                  />
                </div>
              )}
            </div>
          )
        )}
      </div>

      <div className="action-links">
        <a href="/" className="btn">
          Home
        </a>
        <a href="/tours" className="btn">
          Book Another Tour
        </a>
      </div>
    </div>
  );
};

export default Payment;
